<template>
  <v-container
    id="predicao-historico"
    fluid
    tag="section"
  >
    <v-row>
      <v-col 
        cols="12"
      >
        <predicoes-baixas-data-table 
          :items="tableLines"
          :title="tableTitle"
          :loading="loading"
          @recharge="getAllPredicoes()"
          @switchProcessamentosExpirados="
            processamentosExpirados = $event,
            getAllPredicoes()
          "
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PredicoesBaixasService from '@/services/PredicoesBaixasService';
import dayjs from 'dayjs';
import tourMixins from '@/mixins/tourMixins';
import pusherMixins from '@/mixins/pusherMixins';

export default {

  components: {
    PredicoesBaixasDataTable: () => import('@/components/predicoesBaixas/PredicoesBaixasDataTable')
  },
  mixins: [pusherMixins, tourMixins],

  data () {
    return {
      tableTitle: 'Predições de Baixas',
      loading: false,
      processamentosExpirados: false,
      tableLines: [],
      arrTour: [
        {
          element: '#predicao-baixas-create',
          intro: 'Clicando sobre este botão você poderá cadastrar uma nova predição de baixas.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#predicao-baixas-search',
          intro: 'Neste campo é possível realizar uma busca de predições de baixas com base no histórico.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#predicao-baixas-visualizar',
          intro: 'Aqui você poderá visualizar detalhes da predição de baixa.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-more-predicao',
          intro: 'Aqui você acessa outras opções para sua Predição, como executá-la novamente ou deletá-la.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    };
  },

  mounted () {
    this.subscribe();
    this.getAllPredicoes();
  },

  methods: {

    subscribe () {
      this.pusherChannel.bind('refreshPredicoes', data => {
        this.getAllPredicoes();
      });
    },

    getAllPredicoes () {
      this.loading = true;

      PredicoesBaixasService.getPredicoes(this.processamentosExpirados)
        .then(response => {
          this.tableLines = [];
          let obj = {};
          response.data.predicao.forEach(el => {

            obj = {
              id: el.id,
              titulo: el.titulo,
              usuario: el.usuario.nome,
              usuario_id: el.usuario.id,
              precisao: el.precisao,
              base: el.base,
              cenario_vinculado: el.cenario_vinculado ? JSON.parse(el.cenario_vinculado) : null,
              data_base: el.data_base ? dayjs(el.data_base.substr(0, 10)).format('MM/YYYY') : '-',
              executed: el.data_execucao ? dayjs(el.data_execucao).format('DD/MM/YYYY HH:mm') : '-',
              created: el.created,
              status: el.status
            };
            this.tableLines.push(obj);
          });
        })
        .catch(error => console.log(error))
        .finally(() => { this.loading = false, this.iniciarTourPagina(); });
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      let arrTourFormatted = this.tableLines.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    }
  }
};
</script>